import axios from "axios";

global.jQuery = require("jquery");
window.jQuery = window.$ = jQuery;

window.isMobile = false;

(function () {
  let membersPage = {
    buildMem: function () {
      let $members = [],
        markers = [],
        member_ids = [],
        member_ids_map = [],
        map;
      //ACTIVE FILTERS
      const activeFilters = () => {
        let filters = [],
          checked = $("input:checked");

        if (checked && checked.length > 0) {
          $(".filter-results .inner").html(
            '<p class="currentFilterText">Current Filters: </p>'
          );

          $(checked).each(function () {
            let slug = $(this).data("slug"),
              name = $(this).data("value"),
              type = $(this).data("type");
            if (name != "Show Map") {
              filters.push(name);
            }
          });
        }

        if (filters && filters.length > 0) {
          $(filters).each(function () {
            $(".filter-results .inner").append(`
              <div class="item">
                  <p>${this}</p>
              </div>
              `);
          });
        }

        if (checked && checked.length > 0) {
          //console.log(checked.length);
          $("#currentFilters").addClass("filter-open").show();
          $(".filter-results").slideDown();
        } else {
          $("#currentFilters").removeClass("filter-open").hide();
          $(".filter-results").slideUp();
        }
      };
      //CLEAR FILTERS
      const clearFilters = () => {
        $(".filters input").prop("checked", false);
        filterAction();
        $("#currentFilters").removeClass("filter-open").hide();
        $(".filter-results").slideUp();
      };
      const setOneQueryStringParameter = (name, value) => {
        const params = new URLSearchParams(location.search);

        params.set(name, value);

        window.history.replaceState({}, "", `${location.pathname}?${params}`);
      };

      const searchMembers = (name) => {
        let params = urlParamsObj();

        setOneQueryStringParameter("name", name);

        axios
          .post("/api/v1/members/search", {
            member_ids: member_ids,
            page: params.page,
            per_page: params.per_page,
            name: params.name,
            sectors: params.sectors,
            accreditations: params.accreditations,
            locations: params.locations,
            buys: params.buys,
            sells: params.sells,
            sort: params.sort,
            tours: params.tours,
          })
          .then(function (response) {
            buildMembers(response.data.meta, params, true, false);
          });
      };
      const urlParamsObj = (source) => {
        let urlStr = source
          ? source
          : window.location.search
          ? window.location.search
          : "";
        if (urlStr.indexOf("?") > -1) {
          // if there are params in URL
          let param_array = urlStr
              .substring(urlStr.indexOf("?") + 1)
              .split("&"),
            theLength = param_array.length,
            params = {},
            i = 0,
            x;
          for (; i < theLength; i++) {
            x = param_array[i].toString().split("=");
            params[x[0]] = x[1];
          }
          return params;
        }
        return {};
      };
      const setMapOnAll = (map) => {
        let bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < markers.length; i++) {
          markers[i].setMap(map);
        }
      };

      const clearMarkers = () => {
        setMapOnAll(null);
      };

      const buildCurrentVisibleMembers = () => {
        let params = urlParamsObj();
        console.log(params.per_page);
        axios
          .post("/api/v1/members/search/latlng", {
            member_ids: member_ids_map,
            page: params.page,
            per_page: params.per_page,
            name: params.name,
            sectors: params.sectors,
            accreditations: params.accreditations,
            locations: params.locations,
            buys: params.buys,
            sells: params.sells,
            sort: params.sort,
            tours: params.tours,
          })
          .then(function (response) {
            let data = response.data.data;

            setMapOnAll(null);
            clearMarkers();
            markers = [];
            //"Affiliate Member"
            $.each(data.locations, function (i, v) {
              //console.log(v);
              if (v.location.lat && v.location.lng) {
                let microsite_get = "";
                if (
                  v.membership.id === "98e642e1-c3cb-4010-8d87-75eb598a6d53"
                ) {
                  microsite_get = "/login";
                } else {
                  microsite_get = v.microsite.route;
                }
                let infowindow = new google.maps.InfoWindow({
                    content: `<div class="gm-content">
                          <div class="gm-logo">
                              <a href="${microsite_get}">
                                  <img width="100" src="${v.info.logo}"/>
                              </a>
                          </div>
                          <div class="gm-details">
                              <div class="gm-title">
                                  <a href="${microsite_get}">
                                      <h5 style="margin-bottom: 0;">${v.name}</h5>
                                  </a>
                              </div>
                              <div class="gm-address">
                                  <p>${v.info.address}</p>
                              </div>
                          </div>
                      </div>`,
                  }),
                  myLatlng = new google.maps.LatLng(
                    v.location.lat,
                    v.location.lng
                  ),
                  marker = new google.maps.Marker({
                    position: myLatlng,
                    title: v.name,
                    icon: "/images/made-pin.png",
                  });

                google.maps.event.addListener(marker, "click", function () {
                  if (infowindow) {
                    infowindow.close();
                  }
                  // infowindow.close();
                  infowindow.open(map, marker);
                  // infowindow = new google.maps.InfoWindow(map,marker);
                });

                markers.push(marker);
              }
            });

            setMapOnAll(map);
            centerMap(map);
          });
      };

      const centerMap = (map) => {
        let bounds = new google.maps.LatLngBounds();

        $.each(markers, function (i, marker) {
          let latlng = new google.maps.LatLng(
            this.position.lat(),
            this.position.lng()
          );
          bounds.extend(latlng);
        });

        if (markers.length == 1) {
          map.setCenter(bounds.getCenter());
        } else {
          map.fitBounds(bounds);
        }
      };

      window.initMap = function () {
        let MapStyle = [
            {
              featureType: "landscape",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "transit",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "water",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "road",
              elementType: "labels.icon",
              stylers: [{ visibility: "off" }],
            },
            {
              stylers: [
                {
                  hue: "#22222a",
                },
                {
                  saturation: -100,
                },
                {
                  gamma: 1.75,
                },
                {
                  lightness: 5,
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  lightness: 5,
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  lightness: 5,
                },
              ],
            },
          ],
          myLatlng = new google.maps.LatLng(52.4751, -1.8298),
          mapOptions = {
            zoom: 11,
            //center: myLatlng,
            styles: MapStyle,
            mapTypeControl: false,
            streetViewControl: false,
          };

        //map = new google.maps.Map(document.getElementsByClassName("map-canvas"), mapOptions);
        map = new google.maps.Map(
          document.getElementById("map-canvas"),
          mapOptions
        );
      };
      const getMembers = (URLParams, remove) => {
        let params = {
          page: URLParams.page,
          per_page: URLParams.per_page,
          name: URLParams.name,
          sectors: URLParams.sectors,
          accreditations: URLParams.accreditations,
          locations: URLParams.locations,
          buys: URLParams.buys,
          sells: URLParams.sells,
          sort: URLParams.sort,
          tours: URLParams.tours,
        };

        axios
          .post("/api/v1/members/search", {
            per_page: params.per_page,
            name: params.name,
            sectors: params.sectors,
            accreditations: params.accreditations,
            locations: params.locations,
            buys: params.buys,
            sells: params.sells,
            sort: params.sort,
            tours: params.tours,
          })
          .then(function (response) {
            $members.push(response.data.meta.pagination.data);
            buildMembers(response.data.meta, params, false, false);
          })
          .catch(function (error) {
            console.log(error);
          });
      };
      const buildMembers = (meta, params, remove, reload) => {
        let members = meta.pagination.data;
        let loading = $(".loading-spinner"),
          loadMore = $("#loadmore");
        if (reload) {
          location.reload();
        } else {
          if (remove) {
            $(".member").remove();
            $(".results__empty").remove();
            loading.show();
          }
        }
        if (meta && meta.pagination && meta.pagination.total) {
          $("#member__loading").addClass("d-none");
          $("#members_directory").removeClass("d-none");
          $(".members-found").text(
            `${meta.pagination.total} ${
              meta.pagination.total > 1 ? "Companies" : "Company"
            }`
          );
        } else {
          $(".members-found").text("No members found");
        }

        let membersList = jQuery("#members_directory");
        membersList.html("");
        if (members && members.length > 0) {
          member_ids_map = [];
          jQuery.each(members, function (i, v) {
            var chatClass = "d-none";
            var chatClassM = "";
            if (v.enable_live_chat) chatClass = "";
            var matterport = "";
            if (v.matterport.m_1) {
              matterport = v.matterport.m_1;
              chatClassM = "";
            } else if (v.matterport.m_2) {
              matterport = v.matterport.m_2;
              chatClassM = "";
            } else if (v.matterport.m_3) {
              matterport = v.matterport.m_3;
              chatClassM = "";
            } else {
              matterport = "";
              chatClassM = "d-none";
            }
            var followClass = "";
            var followingClass = "d-none";
            if (v.following) {
              followClass = "d-none";
              followingClass = "";
            }
            var quickView = `<a href="javascript:void();" class="open_quick_view" data-site_url="${v.microsite}" data-company_name="${v.name}">Quick View</a>`;
            var visitMicrosite = `<a href="${v.microsite}" class="visit-btn" target="_blank">Visit Microsite</a>`;
            var locationPin = `<span class="mcard-tooltip top">
						<span class="tooltiptext">Locate us</span>
						<a
						href="${v.microsite}/contact-us"
						target="_blank"
						class="member-contact-icon">
							<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-pin" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
								<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
								<circle cx="12" cy="11" r="3"></circle>
								<path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
							</svg>
						</a>
						</span>`;
            if (!v.microsite) {
              quickView = `<a href="/login">Join to view</a>`;
              visitMicrosite = `<a href="/login" class="visit-btn">Login to upgrade</a>`;
              if (___loggedIn) {
                quickView = `<a
								href="#openAff__mem__Popup"
								class="openAff__mem__Popup"
								data-bs-toggle="modal"
								data-bs-target="#openAff__mem__Popup"
								role="button"
								data-company_name="${v.name}"
								data-logo_image="${v.logo}"
								data-address="${v.address}"
								data-tel="${v.telephone}"
								data-web_address="${v.website}"
								data-lat="${v.location.lat}"
								data-lng="${v.location.lng}"
								data-facebook_page_link="${v.facebook_page_link}"
								data-twitter_page_link="${v.twitter_page_link}"
								data-linkedin_page_link="${v.linkedin_page_link}"
								>View Company</a>`;
                visitMicrosite = `<a href="/profile" class="visit-btn">Upgrade Account</a>`;
              }
              locationPin = "";
            }

            member_ids.push(v.id);
            member_ids_map.push(v.id);
            membersList.append(`
            			<div class="col-xl-3 col-lg-4 col-xs-6 col-6 mb-4">
                        <div class="member-card d-flex flex-column h-100">
                            <div class="member-logo d-flex align-items-center justify-content-center">
                                <img
								src="${v.logo}"
								alt="${v.name}"
								class="d-block mx-auto m-0">
                            </div>
                            <div class="member-contact-wrpr">
                                ${locationPin}
                                <span class="mcard-tooltip">
                                    <span class="tooltiptext">Call us</span>
                                    <a
									href="tel:${v.telephone}"
									class="member-contact-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-phone" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
                                        </svg>
                                    </a>
                                </span>
                                <span class="mcard-tooltip ${chatClassM}">
                                    <span class="tooltiptext">3D Tour</span>
                                    <a
                                    href="#!"
                                    data-bs-toggle="modal"
                                    data-bs-target="#openTourPopup"
                                    role="button"
                                    class="member-contact-icon show3dTour"
                                    data-src="${matterport}"
                                    data-id="${v.id}"
                                    data-member_name="${v.name}"
                                    data-microsite="${v.microsite}"
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hexagon-3d" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.25" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M19 6.844a2.007 2.007 0 0 1 1 1.752v6.555c0 .728 -.394 1.399 -1.03 1.753l-5.999 3.844a1.995 1.995 0 0 1 -1.942 0l-6 -3.844a2.007 2.007 0 0 1 -1.029 -1.752v-6.556c0 -.729 .394 -1.4 1.029 -1.753l6 -3.583a2.05 2.05 0 0 1 2 0l6 3.584h-.03z"></path>
                                        <path d="M12 16.5v4.5"></path>
                                        <path d="M4.5 7.5l3.5 2.5"></path>
                                        <path d="M16 10l4 -2.5"></path>
                                        <path d="M12 7.5v4.5l-4 2"></path>
                                        <path d="M12 12l4 2"></path>
                                        <path d="M12 16.5l4 -2.5v-4l-4 -2.5l-4 2.5v4z"></path>
                                    </svg>
                                    </a>
                                </span>

                            </div>
                            <div class="about-member flex-fill">
                                <span
								class="membership-type rounded-pill text-uppercase"
								data-type="${v.membership.name.toLowerCase()}">
                                ${v.membership.name}
								</span>
                                <h3 class="card-title text-uppercase mb-0">
								${v.name}
								</h3>
                            </div>
                            <div class="card-btn-sec justify-content-between">
                                <div class="p-0 m-0 btn-wrap d-none d-md-block">
                                    <button
									onclick="followMember('${v.id}')"
									id="follow__${v.id}"
									class="follow follow-us-btn d-flex justify-content-start ${followClass}">
                                        <span class="follow--us--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
                                                </svg>
                                        </span>
                                        <span class="follow--us---text">Follow</span>
                                    </button>
                                    <button type="button"
                                    class="follow follow-us-btn d-flex justify-content-start following ${followingClass}"
									id="follow__${v.id}__ing">
                                        <span class="follow--us--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                              </svg>
                                        </span>
                                        <span class="follow--us---text">Following</span>
                                    </button>
                                </div>
                                <div class="btn-wrap d-none d-md-block">
                                    ${quickView}
                                </div>
                            </div>
                            <div class="visit-btn-wrap">
                                ${visitMicrosite}
                            </div>
                        </div>
                    </div>

            `);
          });
          if (meta.pagination) {
            membersList.append(
              `<nav class="news__pagination pagination-wrap"><ul class="pagination justify-content-center">${pagination(
                meta.pagination.current_page,
                meta.pagination.last_page
              )}</ul></nav>`
            );
          }
        } else {
          membersList.append(
            '<p class="results__empty" style="padding: 10px 15px;">No Results Found</p>'
          );
        }
        //buildCurrentVisibleMembers();
      };
      const pagination = (c, m) => {
        var current = c,
          last = m,
          delta = 2,
          left = current - delta,
          right = current + delta + 1,
          range = [],
          rangeWithDots = [],
          l,
          html = "";

        for (let i = 1; i <= last; i++) {
          if (i == 1 || i == last || (i >= left && i < right)) {
            range.push(i);
          }
        }

        for (let i of range) {
          if (l) {
            if (i - l === 2) {
              rangeWithDots.push(l + 1);
              html += `
                          <li class="page-item">
                          <a class="page-link" href="#memberFilter__con"
                          onclick="loadMoreMembers('/api/v1/members/search?page=${
                            l + 1
                          }')">
                          ${l + 1}
                          </a>
                          </li>
                          `;
            } else if (i - l !== 1) {
              rangeWithDots.push("...");
              html += `
                          <li class="page-item disabled">
                          <span class="page-link">
                          ...
                          </span>
                          </li>
                          `;
            }
          }
          rangeWithDots.push(i);
          if (i == current) {
            html += `
                      <li class="page-item ${i == current ? `active` : ``}">
                      <span class="page-link">
                      ${i}
                      </span>
                      </li>
                      `;
          } else {
            html += `
                      <li class="page-item">
                      <a class="page-link" href="#memberFilter__con"
                      onclick="loadMoreMembers('/api/v1/members/search?page=${i}')">
                      ${i}
                      </a>
                      </li>
                      `;
          }
          l = i;
        }
        //console.log(rangeWithDots);
        return html;
      };
      const displayMembers = () => {
        let params = urlParamsObj();
        getMembers(params, false);
      };
      displayMembers();

      window.loadMoreMembers = (next_page_url) => {
        let params = urlParamsObj(),
          nextPage = urlParamsObj(next_page_url);

        axios
          .post("/api/v1/members/search", {
            page: nextPage.page,
            per_page: params.per_page,
            name: params.name,
            sectors: params.sectors,
            accreditations: params.accreditations,
            location: params.location,
            buys: params.buys,
            sells: params.sells,
            sort: params.sort,
            tours: params.tours,
            sic_codes: params.sic_codes,
            tenants: params.tenants,
          })
          .then(function (response) {
            buildMembers(response.data.meta, params, false, false);
          });
      };
      //FILTER ACTION
      const filterAction = () => {
        let locations = [];
        $("#filter-locations")
          .find(":checked")
          .each(function () {
            locations.push($(this).val());
          });
        locations = locations.join(",");

        let sectors = [];
        $("#filter-sectors")
          .find(":checked")
          .each(function () {
            sectors.push($(this).val());
          });
        sectors = sectors.join(",");

        let sic_codes = [];
        $("#filter-sic_codes, #filter-sic_codes-mobile")
          .find(":checked")
          .each(function () {
            sic_codes.push($(this).val());
          });
        sic_codes = sic_codes.join(",");
        let tenants = [];
        $("#filter-tenants, #filter-tenants-mobile")
          .find(":checked")
          .each(function () {
            tenants.push($(this).val());
          });
        tenants = tenants.join(",");

        let accreditations = [];
        $("#filter-accreditations, #filter-accreditations-mobile")
          .find(":checked")
          .each(function () {
            accreditations.push($(this).val());
          });
        accreditations = accreditations.join(",");

        let buys = [];
        $("#filter-buys, #filter-buys-mobile")
          .find(":checked")
          .each(function () {
            buys.push($(this).val());
          });
        buys = buys.join(",");

        let sells = [];
        $("#filter-sells, #filter-sells-mobile")
          .find(":checked")
          .each(function () {
            sells.push($(this).val());
          });
        sells = sells.join(",");

        let hasTour = "";
        if ($("#3dTourButton").is(":checked")) {
          hasTour = 1;
        }

        window.history.replaceState(
          {},
          "",
          //`members?locations=${locations}&sectors=${sectors}&accreditations=${accreditations}&buys=${buys}&sells=${sells}&tours=${hasTour}`
          `members?locations=${locations}&sic_codes=${sic_codes}&tenants=${tenants}&accreditations=${accreditations}&buys=${buys}&sells=${sells}&tours=${hasTour}`
        );

        let params = urlParamsObj();

        axios
          .post("/api/v1/members/search", {
            per_page: params.per_page,
            name: params.name,
            sectors: params.sectors,
            accreditations: params.accreditations,
            locations: params.locations,
            buys: params.buys,
            sells: params.sells,
            sort: params.sort,
            tours: params.tours,
            sic_codes: params.sic_codes,
            tenants: params.tenants,
          })
          .then(function (response) {
            buildMembers(response.data.meta, params, true, false);
          })
          .catch(function (error) {
            console.log(error);
          });

        activeFilters();
      };
      $(".filter-container .btn").on("click", activeFilters);
      //Remove individual filters
      $(document).on("click", ".item p", function () {
        let text = $(this).html();
        $('input[data-value="' + text + '"]').prop("checked", false);
        filterAction();
      });
      $(".clear-filters").on("click", clearFilters);
      const debounce = (func, wait) => {
        let timeout;

        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };

          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      };
      $(document).ready(function () {
        if ($("#members_directory").length) {
          let params = urlParamsObj(),
            search = $("#member-search");
          let searchMobile = $("#member-search-mobile");

          if (params.name) {
            search.focus().val(params.name);
          }

          if (!params.page) {
            params.page = 1;
          }

          if (!params.per_page) {
            params.per_page = 12;
          }

          if (params.sort) {
            let text = $("#sort");
            if (params.sort === "abc") {
              text.html('<i class="far fa-sort"></i>Sort: Name');
            } else {
              text.html('<i class="far fa-sort"></i>Sort: Rank');
            }
          }

          /*search.keyup(debounce(function(){
					searchMembers(search.val());

					}, 500));*/
          let typingTimer; //timer identifier
          let doneTypingInterval = 300;

          search.on("keyup", function () {
            //clearTimeout(typingTimer);
            //typingTimer = setTimeout(doneTyping, doneTypingInterval);
            searchMembers(search.val());
          });

          //on keydown, clear the countdown
          search.on("keydown", function () {
            clearTimeout(typingTimer);
          });

          //user is "finished typing," do something
          function doneTyping() {
            searchMembers(search.val());
          }

          /* search.on("keyup", function () {
            console.log(search.val());
            setTimeout(searchMembers(search.val()), 1000);
          }); */

          /* search.on(
            "keyup",
            debounce(function (event) {
              console.log(search.val());
              searchMembers(search.val());
            }, 300)
          ); */
          searchMobile.on(
            "keyup",
            debounce(function (event) {
              searchMembers(searchMobile.val());
            }, 300)
          );

          /* search.on("change", function (event) {
            //console.log(search.val());
            searchMembers(search.val());
          });
          searchMobile.on("change", function (event) {
            //console.log(searchMobile.val());
            searchMembers(searchMobile.val());
          }); */
          getMembers(params, false);
          $("#show-map-btn,.innner-show-map-btn").on("click", function () {
            //console.log(member_ids);
            initMap();
            buildCurrentVisibleMembers();
          });
          $(".filter-form").submit(function (event) {
            event.preventDefault();

            filterAction();

            $(".filter-container").removeClass("active").slideUp();
            $(".filters .btn").removeClass("active");
          });

          $("#3dTourButton").on("change", function (event) {
            filterAction();

            $(".filter-container").removeClass("active").slideUp();
            $(".filters .btn").removeClass("active");
          });

          let url = urlParamsObj();

          if (url.locations && url.locations.length) {
            let locations = url.locations.split(",");

            $("#filter-locations :checkbox").each(function () {
              if (locations.includes($(this).val())) {
                $(this).prop("checked", true);
              }
            });
          }

          if (url.sectors && url.sectors.length) {
            let sectors = url.sectors.split(",");

            $("#filter-sectors :checkbox").each(function () {
              if (sectors.includes($(this).val())) {
                $(this).prop("checked", true);
              }
            });
          }

          if (url.accreditations && url.accreditations.length) {
            let accreditations = url.accreditations.split(",");

            $(
              "#filter-accreditations :checkbox, #filter-accreditations-mobile :checkbox"
            ).each(function () {
              if (accreditations.includes($(this).val())) {
                $(this).prop("checked", true);
              }
            });
          }

          if (url.buys && url.buys.length) {
            let buys = url.buys.split(",");

            $("#filter-buys :checkbox, #filter-buys-mobile :checkbox").each(
              function () {
                if (buys.includes($(this).val())) {
                  $(this).prop("checked", true);
                }
              }
            );
          }

          if (url.sells && url.sells.length) {
            let sells = url.sells.split(",");

            $("#filter-sells :checkbox, #filter-sells-mobile :checkbox").each(
              function () {
                if (sells.includes($(this).val())) {
                  $(this).prop("checked", true);
                }
              }
            );
          }
        }
      });
    },
    init: function () {
      this.buildMem();
    },
  };
  membersPage.init();
})();

function initMap_aff(_lat, _lng, _companyName) {
  const myLatLng = { lat: _lat, lng: _lng };
  const map = new google.maps.Map(document.getElementById("aff__map"), {
    zoom: 13,
    center: myLatLng,
  });

  new google.maps.Marker({
    position: myLatLng,
    map,
    title: _companyName,
  });
}

$(".parentCheckBox").on("click", function () {
  var get_p_class = $(this).data("parent_class");
  if ($(this).prop("checked") == true) {
    $("." + get_p_class).prop("checked", true);
  } else {
    $("." + get_p_class).prop("checked", false);
  }
});
$(document).on("click", ".openAff__mem__Popup", function () {
  let _companyName = $(this).attr("data-company_name");
  let _logoImage = $(this).attr("data-logo_image");
  let _address = $(this).attr("data-address");
  let _tel = $(this).attr("data-tel");
  let _webAddress = $(this).attr("data-web_address");
  let _lat = $(this).attr("data-lat");
  let _lng = $(this).attr("data-lng");
  let _facebookPageLink = $(this).attr("data-facebook_page_link");
  let _twitterPageLink = $(this).attr("data-twitter_page_link");
  let _linkedinPageLink = $(this).attr("data-linkedin_page_link");

  $("#aff__company_name, #openAffLabel").text(_companyName);
  $("#aff__logo_image").attr("src", _logoImage);
  $("#aff__address").text(_address);
  $("#aff__tel").text(_tel);
  $("#aff__web_address").text(_webAddress);
  $("#aff__visitMicrosite").attr("href", _webAddress);
  $("#aff__lat").text(_lat);
  $("#aff__lng").text(_lng);
  $("#aff__facebook_page_link").attr("href", _facebookPageLink);
  $("#aff__twitter_page_link").attr("href", _twitterPageLink);
  $("#aff__linkedin_page_link").attr("href", _linkedinPageLink);
  initMap_aff(parseFloat(_lat), parseFloat(_lng), _companyName);
});
